<template>
  <div>
    <div class="row" v-if="confirm_type == 3">
      <div class="col-sm-12">
        <div class="form-group m-b-10">
          <label class="col-form-label control-label required">{{
            $t('stockTransfer.reason')
          }}</label>
          <div>
            <textarea
              v-model="model.approved_comment"
              placeholder="Approved Comment"
              rows="3"
              class="form-control"
              :class="{ 'is-invalid': errors.has('approved_comment') }"
            ></textarea>
          </div>
        </div>
      </div>
    </div>
    <div class="row ts-mt-0">
      <div class="col-sm-12 col-lg-12 col-md-12 text-right">
        <ts-button
          color="danger"
          class="btn-sm"
          @click.prevent="$emit('cancel')"
          :disabled="saving"
          >{{ $t('no') }}</ts-button
        >
        <ts-button
          color="primary"
          class="ml-2 btn-sm"
          :waiting="saving"
          @click.prevent="confirm()"
          >{{ $t('yes') }}</ts-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'

export default {
  props: ['value', 'validate', 'confirm_type'],
  name: 'confirm-form',
  data() {
    return {
      model: {
        stock_transfer_id: '',
        transfer_status_id: 2,
        received_date: null,
      },
      errors: new Errors(),
      saving: false,
      confirmData: [],
      model: [],
    }
  },
  created() {
    this.model = Object.assign({}, this.model, {
      receipt_id: this.value.receipt_id,
      approved_comment: null,
      approve_status: null,
    })
  },
  methods: {
    confirm() {
      this.errors = new Errors()
      this.saving = true
      this.model.approve_status = this.confirm_type
      this.$store
        .dispatch('wholesale/receipt/confirm', this.model)
        .then((response) => {
          this.$emit('cancel')
          this.$toasted.success(response.message)
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.saving = false
        })
    },
  },
  watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors)
    },
  },
}
</script>
